import { EditIcon } from "@root/assets/icons/editIcon";
import DeleteIcon from "@root/assets/icons/delete-02.svg";
import { Flex, Image, Box } from "@chakra-ui/react";
import { ACTION } from "@root/constants";

export const OrganizationsTableColumns = (handleActions: any, t: any) => {
    return [
        {
            cell: (info: any) => {
                const logo = info?.row?.original?.logo;
                return logo ? (
                    <Image
                        src={logo}
                        alt={info?.row?.original?.name || "Logo"}
                        width="40px"
                        height="40px"
                        objectFit="contain"
                        borderRadius="4px"
                    />
                ) : (
                    <Box
                        width="40px"
                        height="40px"
                        bg="gray.200"
                        borderRadius="4px"
                    />
                );
            },
            header: t("superAdmin.logoColumn"),
        },
        {
            cell: (info: any) => info?.row?.original?.name || "",
            header: t("superAdmin.nameColumn"),
        },
        {
            cell: (info: any) => info?.row?.original?.email || "",
            header: t("superAdmin.emailColumn"),
        },
        {
            cell: (info: any) => info?.row?.original?.domain || "",
            header: t("superAdmin.domainColumn"),
        },
        {
            cell: (info: any) => (
                <Flex gap={"14px"}>
                    <Flex
                        gap={"8px"}
                        cursor={"pointer"}
                        onClick={() => handleActions(ACTION.EDIT, info?.row?.original)}
                    >
                        <EditIcon />
                    </Flex>
                    <Flex
                        gap={"8px"}
                        cursor={"pointer"}
                        onClick={() => handleActions(ACTION.DELETE, info?.row?.original)}
                    >
                        <Image src={DeleteIcon} width={18} />
                    </Flex>
                </Flex>
            ),
            header: t("superAdmin.actionsColumn"),
        },
    ];
};
